import { render } from "./StatsList.vue?vue&type=template&id=62bd92b8&scoped=true"
import script from "./StatsList.vue?vue&type=script&lang=ts"
export * from "./StatsList.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-62bd92b8"

export default script